<template>
  <vk-modal-body>
    <services-modal-header>
      Checking Availability for {{ service.service_display_name || service.name }}
    </services-modal-header>
    <services-modal-body>
      <div
          v-show="!locations.length"
          class="text-center"
          selenium="modal-zipcode">
        Provide the zipcode for your service location.
        <div class="d-flex:t jc-center:t ai-center:t m-1">
          <location-form/>
        </div>
      </div>
      <div
          v-show="locations.length"
          class="layout gap-2 ai-center"
          selenium="city-modal-container">
        <div
            v-for="(location,index) in locations"
            :key="index"
            class="layout-item is-12 is-6:t">
          <button
              :selenium="`city-name-button:${index + 1}`"
              class="w-100 p-l-5 p-r-5 btn-secondary"
              @click="selectCity(location)">
            {{ location.city }}, {{ location.state }}
          </button>
        </div>
      </div>
    </services-modal-body>
  </vk-modal-body>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import LocationForm from './components/LocationForm';
import ServicesModalHeader from './components/ServicesModalHeader';
import ServicesModalBody from './components/ServicesModalBody';

export default {
  name: 'zipcode-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
    LocationForm,
  },
  props: {
    locations: {
      type: Array,
      required: false,
      default: () => { return []; },
    },
    service: {
      type: Object,
      required: true,
    },
  },
  created () {
    this.ensureInteractionId();
    const payload = {
      sp_flow: 'the_home_depot_proreferral',
      app_name: 'proreferral',
    };

    if (this.service && this.service.service_identifier) {
      payload.service_identifier = this.service.service_identifier;
    }

    this.$store.dispatch('riskAssesment/fetchRiskAssessmentConfig', payload);
  },
  methods: {
    ensureInteractionId () {
      if (!this.interactionId) {
        this.$store.commit('recaptcha/updateUserInteractionId', uuidv4());
      }
    },
    selectCity (location) {
      this.$store.commit('homepage/geo/selectedLocation', location);
    },
  },
};
</script>
